import { observer } from "mobx-react";
import React from "react";
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";

import { useRecordVersion } from "@/api/queries/recordVersions";
import Loading from "@/components/Loading";

import { ModuleAssessmentDetails } from "./ModuleAssessmentDetails";
import { ModuleAssessmentsList } from "./ModuleAssessmentsList";

export const MODULE_ASSESSMENT_ROUTES = {
  base: "/module_assessments",
  details: "/:moduleAssessmentId",
} as const;

export const MODULE_ASSESSMENTS_LIST_PATH =
  `/workspaces/:workspace_id/modules/control-mapping/:record_version_id${MODULE_ASSESSMENT_ROUTES.base}` as const;

export const ModuleAssessmentRoutes = observer(() => {
  const { path } = useRouteMatch();
  const { record_version_id } = useParams<{
    record_version_id: string;
  }>();

  const { data: recordVersionData, isPending } = useRecordVersion(
    Number(record_version_id),
  );

  const moduleWorkspaceID =
    recordVersionData?.data?.record_version?.record?.module_workspace_id || 0;

  if (isPending) {
    return <Loading loadingLayout="table" />;
  }

  return (
    <Switch>
      <Route path={`${path}${MODULE_ASSESSMENT_ROUTES.details}`}>
        <ModuleAssessmentDetails
          recordVersionId={Number(record_version_id)}
          moduleWorkspaceID={moduleWorkspaceID}
        />
      </Route>
      <Route exact path={path}>
        <ModuleAssessmentsList recordVersionId={Number(record_version_id)} />
      </Route>
    </Switch>
  );
});
